import React from 'react';

interface SettingsToggleProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  'data-testid'?: string;
  'aria-label'?: string;
  disabled?: boolean;
}

export const SettingsToggle: React.FC<SettingsToggleProps> = ({
  id,
  checked,
  onChange,
  'data-testid': testId,
  'aria-label': ariaLabel,
  disabled = false,
}) => {
  return (
    <label
      htmlFor={id}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: 38,
        height: 22,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        flexShrink: 0,
      }}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
        aria-label={ariaLabel}
        disabled={disabled}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
          position: 'absolute',
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: checked
            ? 'var(--tome-ochre, #b98a2e)'
            : 'rgba(110, 79, 42, 0.22)',
          border: `1px solid ${
            checked
              ? 'var(--tome-gilt, #d8a648)'
              : 'var(--tome-rule-strong, rgba(110, 79, 42, 0.35))'
          }`,
          borderRadius: 22,
          transition: 'all 0.2s ease',
          boxShadow: checked ? '0 0 6px rgba(185, 138, 46, 0.35)' : 'none',
        }}
      >
        <span
          style={{
            position: 'absolute',
            content: '""',
            height: 16,
            width: 16,
            left: checked ? 18 : 2,
            bottom: 2,
            backgroundColor: checked ? '#ffffff' : '#fcf8ee',
            borderRadius: '50%',
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 1px 3px rgba(42, 29, 18, 0.3)',
          }}
        />
      </span>
    </label>
  );
};
